import IbanPDF from './IbanPDF';

export default IbanPDF;